import React, { useState, useEffect, useRef } from 'react';
import { useStaticDataStore } from '../../stores/staticData';
import { formattedDate } from '../../utils/formattedDate';

import dummyFounder from '../../assets/images/dummyFounder.png'
import { USER_EDIT_STATUS, USER_PROFILE_PLAN } from '../../constants/common';
import { getReportDetailApi, suspendReportApi } from '../../api/usersApi';

const EditReport = ({ setEditReport, ref, selectedReport, isEditReport, handleActionUser, isSuspendLoading, setSelectedReport, handleIgnoreUSer, isIgnoreLoading, handleReopenUser }) => {
    const { data: staticData } = useStaticDataStore();

    let reportReason = [];
    if (staticData?.reportForFounders?.length) {
        reportReason = staticData?.reportForFounders;
    }
    const [editSliderData, setEditSliderData] = useState();
    const [isLoadingData, setIsLoadingData] = useState(true);

    const userType = USER_EDIT_STATUS;
    const statusLabel = userType?.find((item) => item?.key === editSliderData?.status)?.value;
    const userPlan = USER_PROFILE_PLAN;

    useEffect(() => {
        if (selectedReport?.id) {
            const fetchData = async () => {
                try {
                    setIsLoadingData(true)
                    const response = await getReportDetailApi(selectedReport?.id)
                    if (response) {
                        setEditSliderData(response)
                    }
                } catch (error) {
                    console.log(error);
                    setIsLoadingData(false)
                }
            }
            fetchData();
        }
    }, [selectedReport?.id]);

    useEffect(() => {
        if (editSliderData && editSliderData !== undefined) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 3000);
        }
    }, [editSliderData]);

    useEffect(() => {
        if (!isEditReport) {
            setSelectedReport({})
        }
    }, [isEditReport])

    useEffect(() => {
        if (isEditReport) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }, [isEditReport]);

    const typeMap = {
        1: "Founder",
        2: "Angel",
        3: "VC",
        4: "Accelerator",
    };
    const statusMap = {
        1: "Active",
        2: "Not Completed",
        3: "Suspended"
    };

    const LazyImage = ({ src, alt }) => {
        const [isVisible, setIsVisible] = useState(false);
        const imgRef = useRef();

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 }
            );

            if (imgRef.current) {
                observer.observe(imgRef.current);
            }

            return () => {
                if (imgRef.current) {
                    observer.unobserve(imgRef.current);
                }
            };
        }, []);

        return (
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                loading="lazy"
            />
        );
    };

    return (
        <>
            <div className={`${isEditReport && 'popup-overlay'}`}></div>
            <div className={`report-profile-popup ${isEditReport ? 'show' : ''}`} ref={ref}>
                <div className='popup-box'>
                    <div className="popup-close" onClick={() => { setEditReport(false) }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div
                        className={`report-basic-info pagesTable dataTable-list ${isLoadingData ? 'loading-list profile-data-loader' : ''
                            }`}
                    >
                        <div className="report-number">
                            Report #{editSliderData?.id}
                            <span className={`report-type ${statusLabel}`}>
                                {statusLabel}
                            </span>
                        </div>
                        <div className='report-date'>Reported on {formattedDate(editSliderData?.dateOfReported)}</div>
                        {
                            editSliderData?.status !== 'OPEN' &&
                            <button
                                className={`report-reopen button ${isIgnoreLoading ? 'btn_loading' : ''
                                    }`}
                                onClick={() => { handleReopenUser(editSliderData); }}
                            >
                                {isIgnoreLoading ? (
                                    <div className="registerLoader">
                                        <div className="ring-loader"></div>
                                    </div>
                                ) : (
                                    'Re-open report'
                                )}
                            </button>
                        }
                        <div className="user-details">
                            <div className="reported">
                                <span className='label'>User reported</span>
                                <div className="user-name">
                                    <div className='reported-user-image'>
                                        <LazyImage
                                            src={editSliderData?.reportedProfileImg || dummyFounder}
                                            alt="Reported user image"
                                        />
                                    </div>
                                    <div className='user-report-name'>{editSliderData?.reportedName}</div>
                                    <div className={`user-type ${typeMap[editSliderData?.reportedType]}`}>
                                        {typeMap[editSliderData?.reportedType]}
                                    </div>
                                    <div className={`user-plan ${statusMap[editSliderData?.reportedStatus]}`} >
                                        {statusMap[editSliderData?.reportedStatus]}{" "}
                                        {editSliderData?.reportedPlan
                                            ? `(${userPlan?.find(plan => plan?.key === editSliderData?.reportedPlan)?.value || editSliderData?.reportedPlan})`
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="reported-by">
                                <span className='label'>Reported by</span>
                                <div className="user-name">
                                    <div className='reported-user-image'>
                                        <LazyImage
                                            src={editSliderData?.reportByProfileImg || dummyFounder}
                                            alt="Reported by user image"
                                        />
                                    </div>
                                    <div className='user-report-name'>{editSliderData?.reportByName}</div>
                                    <div className={`user-type ${typeMap[editSliderData?.reportByType]}`}>
                                        {typeMap[editSliderData?.reportByType]}
                                    </div>
                                    <div className={`user-plan ${statusMap[editSliderData?.reportedByStatus]}`}>
                                        {statusMap[editSliderData?.reportedByStatus]}
                                    </div>
                                </div>
                            </div>
                            <div className="reason-block">
                                <span className="label">Reason</span>
                                <div className="reason-list">
                                    {
                                        editSliderData?.reasons?.map((reasonKey, index) => {
                                            const matchedReason = reportReason.find(r => r.key === reasonKey);
                                            return (
                                                <span key={index}>
                                                    {matchedReason ? matchedReason.value : reasonKey}
                                                </span>
                                            );
                                        })
                                    }
                                </div>

                            </div>
                            <div className="report-number-block">
                                <span className="label">Number of reports on James</span>
                                <div className="report-number">
                                    {editSliderData?.numberOfReportsOnUser}
                                </div>
                            </div>
                            {
                                editSliderData?.status === 'OPEN' &&
                                <>
                                    <div className="divider full"></div>
                                    <div className='save-button-group'>
                                        <button
                                            className={`cancel-button button ${isIgnoreLoading ? 'btn_loading' : ''
                                                }`}
                                            onClick={() => { handleIgnoreUSer(editSliderData); }}
                                        >
                                            {isIgnoreLoading ? (
                                                <div className="registerLoader">
                                                    <div className="ring-loader"></div>
                                                </div>
                                            ) : (
                                                'Ignore'
                                            )}
                                        </button>
                                        <button
                                            className={`save-button button ${isSuspendLoading ? 'btn_loading' : ''}`}
                                            onClick={() => handleActionUser(editSliderData)}
                                        >
                                            <span className="btn-text">
                                                Suspend {editSliderData?.reportedName}
                                            </span>
                                            {isSuspendLoading && (
                                                <div className="registerLoader">
                                                    <div className="ring-loader"></div>
                                                </div>
                                            )}
                                        </button>

                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div >
        </>

    )
}

export default EditReport